<template>
    <div>
        <div class="panel mb-0">
            <div class="panel-hdr d-block pt-4 p-3">
                <div class="row pl-0">
                    <div class="col-sm-12 col-md-6 mb-2 align-items-center justify-content-start">
                        <div class="dataTables_filter">
                            <label class="d-flex mb-0">
                                <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchStaff" @keypress.enter="filterSearchStaff">
                                <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0" @click="filterSearchStaff">
                                    <i class="fas fa-search"></i>
                                </button>
                            </label>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 mb-2"> 
                        <div class="form-group d-flex">
                            <div class="input-group-prepend w-100">
                                <label class="input-group-text border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                                    <i class="fas fa-store"></i>
                                </label>
                                <multiselect  v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                                    <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                </div>
                <a class="link text-primary" @click="clearFilter">{{$t('button_link.clear_filter')}}</a>
            </div>
            <div class="panel-container">
                <div class="panel-content">
                    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                        <b-spinner label="Loading..."></b-spinner>
                    </div>
                    <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
                        {{$t('table.no_records')}} {{$t('message.info.add_tukang', {'item': $t('subMenu.salon_setting_staff')})}}
                    </div>
                    <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                        <div class="row justify-content-end mt-2">
                            <div class="col-auto pt-2 mb-2">
                                <span>{{$t('table.pagination_short', {'totalEntries': totalEntries})}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 overflow-auto">
                                <b-table striped hover bordered :fields="fields" :items="staffItems" responsive="sm">
                                    <template #cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>
                                    <template #cell(image)="data">
                                        <b-carousel v-if="data.item.TkStylistImage.length != 0"
                                            :interval="0"
                                            controls>
                                            <b-carousel-slide v-for="img in data.item.TkStylistImage" :key="img.id"
                                                img-height="240"
                                                :img-src="img.src"
                                            ></b-carousel-slide>
                                        </b-carousel>
                                        <span v-else>-</span>
                                    </template>
                                    <template #cell(name)="data">
                                        <a class="text-primary fw-500 link" @click="editTukangStylist(data.item)">
                                            {{data.item.TkStylistName}}
                                        </a>
                                    </template>
                                    <template #cell(details)="data">
                                            {{data.item.TkStylistDetails == '' ? '-' : data.item.TkStylistDetails}}
                                    </template>
                                    <template #cell(isEnableTukang)="data">
                                        <span class="badge" :class="data.item.isEnableTukang == 1 ? 'badge-primary' : 'border border-secondary text-secondary'">{{data.item.isEnableTukang == 1 ? $t('table.value.enable') : $t('table.value.disable')}}</span>
                                    </template>
                                    <template #cell(action)="data">
                                        <a class="text-primary link" :title="$t('button_link.disable', {'item': $t('tukang.stylist')})" @click="showDeleteModal(data.item)">
                                            <i class="fal fa-trash"></i>
                                        </a>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': editToggle }" class="modal fade">
            <div class="modal-dialog modal-lg">
                <div class="modal-content modal-content-lg">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('button_link.edit') + $t('subMenu.my_salon_tukang') + $t('subMenu.salon_setting_staff')}}
                            <small class="m-0 text-muted">{{$t('subMenu.salon_setting_staff')}} - "{{sTitle}}"</small>
                        </h5>
                        <button type="button" class="close" @click="editToggle = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body modal-body-lg">
                        <tukangStaffForm ref="tukangStaffForm" @returnStaffList="returnStaffList"></tukangStaffForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash'
import TukangStaffForm from './Tukang_Staff_Form'
import {handleSessionExpired} from '@/assets/js/dashboard/dashboard.js'
export default {
    name: "tukangStaff",
    props:{
        cityList: {type: Array}
    },
    components:{
        TukangStaffForm, 
    },
    data(){
        return{
            editToggle: false,
            TkStylistImage: [], isSpinnerShow: false, sTitle: "",
            staffItems: [], selectedItem: {},
            stylistID: 0,
            totalEntries: 0,
            searchStaff: "",
            outlet: [], selectedOutlet: {},
        }
    },
    computed:{
        fields(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "image", label: this.$i18n.t('tukang.stylist') + ' ' + this.$i18n.t('label.image'), thClass: 'thead-themed align-middle', tdClass: 'td-img-width align-middle text-center'},
                { key: "name", label: this.$i18n.t('table.header.name'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "mobile", label: this.$i18n.t('table.header.contact'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "details", label: this.$i18n.t('label.details'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "isEnableTukang", label: this.$i18n.t('table.header.enable_tukang'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
            ]
        }
    },
    methods:{
        async closeModal(isError){
            if(!isError){
                await this.setStaffItems("")
            }
            this.$parent.$parent.isModalShow = false
        },
        getCity(id){
            var city = ""
            for(var i=0; i<this.cityList.length; i++){
                if(parseInt(id) == this.cityList[i].cityID){
                    city = this.cityList[i].city
                    break
                }
            }
            return city
        },
        clearFilter(){
            this.searchStaff = ""
            this.selectedOutlet = this.outlet[0];
            this.setStaffItems("");
        },
        filterSearchStaff(){
            var strFilter = this.searchStaff == "" ? "" : "?search=" + this.searchStaff;
            this.setStaffItems(strFilter);
        },
        filterByOutlet(item){
            this.selectedOutlet = item;
            this.filterSearchStaff();
        },
        setTukangInitial(obj){
            obj.outletID
            obj.TkStylistImage = []
            obj.TkStylistCityID = ""
            obj.TkStylistLocation = ""
            obj.TkStylistMobile = obj.mobile
            obj.TkStylistName = obj.name
            obj.TkStylistTitle = "",
            obj.TkStylistDetails = obj.details
            obj.outletID = this.selectedOutlet.id

            return obj
        },
        async setStaffItems(staffFilter){
            let $vm = this
            this.isSpinnerShow = true
            var tukangStaff = await this.getTukangStaff()
            var staff = await this.getStaffItems(staffFilter)

            if(tukangStaff.length == 0){
                staff.forEach(function(obj){
                    obj = $vm.setTukangInitial(obj)
                    obj.isEnableTukang = 0
                })
                this.staffItems = staff
            }else{
                var merged = _.map(staff, function(item) {
                    var f = _.find(tukangStaff, ['staffID', item.staffID])
                    var obj = {}
                    if(f == undefined){
                        obj = $vm.setTukangInitial(item)
                        obj.isEnableTukang = 0
                    }else{
                        obj = f
                        obj.isEnableTukang = 1
                    }
                    var m =  _.assign(item, obj);
                    return m
                });
                this.staffItems = merged
            }
            this.totalEntries = this.staffItems.length
            this.isSpinnerShow = false
        },
        async getTukangStaff(){
            this.staffItems = []
            let $vm = this;
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: $vm.$api.TUKANG_SHOP + $vm.$api.TUKANG_STAFF,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })

            for(var i=0; i<result.length; i++){
                var image = []
                for(var j=1; j<=6; j++){
                    var key = "TkStylistImage" + j
                    if(result[i][key] != ""){
                        image.push({
                            index: j,
                            id: key,
                            src: result[i][key],
                            thumbnail: result[i][key],
                        })
                    }
                }
                result[i].TkStylistImage = image
            }
            
            return result
        },
        async getStaffItems(strFilter){
            let $vm = this;
            let QUERY_STRING =  "/" + this.selectedOutlet.id + this.$api.STAFF + strFilter
            const url =  this.$api.OUTLET + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.staff                
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
            return result
        },
        async returnStaffList(){
            this.editToggle = false
            await this.setStaffItems("")
        },
        editTukangStylist(item){
            this.selectedItem = item
            this.sTitle = item.TkStylistName
            this.editToggle = true
            this.$refs.tukangStaffForm.editTukangStaffForm(item)
        },
    },
    async mounted(){
        let $vm = this
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];
        await $vm.setStaffItems("")
    },
}
</script>
<style scoped>
.show{
    display: block;
}
.modal-body-lg{
    max-height: 75vh;
    overflow-y: auto;
}
.modal-lg{
    max-width: 1000px;
}
</style>